import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import React from 'react'
import { config } from '../../../../config';
import { useParams } from "react-router-dom"

function CheckoutForm(props) {
    const stripe = useStripe();
    const elements = useElements();
    const [message, setMessage] = React.useState(null);
    const [paymentProcessing, setPaymentProcessing] = React.useState(false);

    let { lid, season, slug } = useParams();

    const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setPaymentProcessingStatus(true);
        const result = await stripe.confirmPayment({
            //`Elements` instance that was used to create the Payment Element
            elements,
            confirmParams: {
                return_url: config.stripe.redirect_uri + '?lid=' + lid + '&season=' + season + '&slug=' + slug,
            },
            redirect: 'if_required'
        });


        if (result.error) {
            // This point will only be reached if there is an immediate error when
            // confirming the payment. Show error to your customer (for example, payment
            // details incomplete)
            setMessage(result.error.message);
            setPaymentProcessingStatus(false);
        } else {
            // Your customer will be redirected to your `return_url`. For some payment
            // methods like iDEAL, your customer will be redirected to an intermediate
            // site first to authorize the payment, then redirected to the `return_url`.

            // Retrieve the "payment_intent_client_secret" query parameter appended to
            // your return_url by Stripe.js
            // const clientSecret = new URLSearchParams(window.location.search).get(
            //     'payment_intent_client_secret'
            // );

            // Retrieve the PaymentIntent
            stripe
                .retrievePaymentIntent(result.paymentIntent.client_secret)
                .then(({ paymentIntent }) => {

                    // Inspect the PaymentIntent `status` to indicate the status of the payment
                    // to your customer.
                    //
                    // Some payment methods will [immediately succeed or fail][0] upon
                    // confirmation, while others will first enter a `processing` state.
                    //
                    // [0]: https://stripe.com/docs/payments/payment-methods#payment-notification
                    switch (paymentIntent.status) {
                        case 'succeeded':
                            props.onPaymentConfirmed(result.paymentIntent.id);
                            setPaymentProcessingStatus(false);
                            break;

                        case 'processing':
                            setMessage("Payment processing. We'll update you when payment is received.");
                            setPaymentProcessingStatus(false);
                            break;

                        case 'requires_payment_method':
                            // Redirect your user back to your payment page to attempt collecting
                            // payment again
                            setMessage('Payment failed. Please try another payment method.');
                            setPaymentProcessingStatus(false);
                            break;

                        default:
                            setMessage('Something went wrong.');
                            setPaymentProcessingStatus(false);
                            break;
                    }
                });

        }
    };

    function setPaymentProcessingStatus(isProcessing) {
        setPaymentProcessing(isProcessing);
        props.setPaymentProcessing(isProcessing);
    }

    return (
        <>
            <form id='paymentForm' onSubmit={handleSubmit}>
                <PaymentElement options={{ readOnly: paymentProcessing }} />
            </form>
            {message &&
                <div className="alert alert-danger mt-3" role="alert">
                    {message}
                </div>
            }
        </>
    )
}


export default CheckoutForm